var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1573_4971)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM2.80079 8.85558C2.80079 9.04217 2.94947 9.19826 3.14014 9.19826L4.37828 9.19247L6.00081 7.19805L7.62505 9.19425L8.86145 9.20005C9.05373 9.20005 9.20079 9.04051 9.20079 8.85736C9.20079 8.77471 9.17115 8.70019 9.12597 8.64197L6.97661 6.00004L9.12138 3.36351L9.1242 3.35988C9.16938 3.30166 9.19906 3.22717 9.19906 3.14452C9.19906 2.95793 9.05039 2.80184 8.85972 2.80183L7.62331 2.80763L6.00086 4.80195L4.37833 2.80584L3.1392 2.80005C2.94692 2.80005 2.80078 2.95958 2.80078 3.14274L2.8008 3.1449C2.80165 3.22285 2.8283 3.29892 2.87747 3.3604L5.02659 5.99831L2.87853 8.63652L2.87566 8.64022C2.83048 8.69844 2.80079 8.77293 2.80079 8.85558Z",
    fill: "#D82A46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1573_4971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.68bc695b9d55d20d2df57a827262f813.svg";
export { ForwardRef as ReactComponent };